/* eslint-disable import/prefer-default-export */
import { useContext } from 'react';
import { AuthContext } from 'authentication/AuthContext';

// prettier-ignore
export const useGetCarrierParams = () => {
  const { 
    currentAffiliate: { 
      customerIdName, 
      dataCompanyId 
    } = {} 
  } = useContext(AuthContext);

  return { 
    carrier: { 
      carrierId: customerIdName, 
      magellanId: dataCompanyId 
    } 
  };
};
